import { SessionModel } from "../domain/session";

export const sessionState: SessionModel = {
    id: "",
    qrcode: "",
    name: "",
    workoutId: "",
    link: "",
};
